import Vue from "vue";
import { ValidationErrors } from "./new-contract-vue";

class NewContractEventBus {
    private vue: Vue = new Vue();

    removeNewContractInitializedListener(listener: () => void) {
        this.vue.$off("new-contract-initialized", listener);
    };

    addNewContractInitializedListener(listener: () => void) {
        this.vue.$on("new-contract-initialized", listener);
    };

    notifyNewContractInitialized() {
        this.vue.$emit("new-contract-initialized");
    }


    addValidationFailedListener(listener: (ValidationErrors) => any) {
        this.vue.$on("validation-failed", listener);
    }

    removeValidationFailedListener(listener: (ValidationErrors) => any) {
        this.vue.$off("validation-failed", listener);
    }

    notifyValidationFailed(validationErrors: ValidationErrors) {
        this.vue.$emit("validation-failed", validationErrors);
    }

    addProductSelectionClearedListener(listener: () => any) {
        this.vue.$on("product-selection-cleared", listener);
    }

    removeProductSelectionClearedListener(listener: () => any) {
        this.vue.$off("product-selection-cleared", listener);
    }

    notifyProductSelectionCleared() {
        this.vue.$emit("product-selection-cleared");
    }

    addNotifySessionExpiredListener(listener: () => void) {
        this.vue.$on("notify-session-exception", listener);
    }

    removeNotifySessionExpiredListener(listener: () => void) {
        this.vue.$off("notify-session-exception", listener);
    }

    notifySessionExpired() {
        this.vue.$emit("notify-session-exception", true);
    }
}

export const NewContractEvents = new NewContractEventBus();